module.exports = __webpack_public_path__ + "static/img/bolang.9ebf647.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardiobrain/bolang.png
// module id = ub4d
// module chunks = 5